/* eslint-disable max-len */
import React from 'react';

const InsertPluginMobileIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={11} height={14} viewBox="0 0 11 14" {...props}>
    <g fill="none" fillRule="evenodd">
      <path stroke="currentColor" d="M.5.5v13h10V5.499H5.49V.5H.5z" />
      <path
        fill="currentColor"
        d="M5 1h1v1H5zM6 0h1v1H6zM9 5h1v1H9zM9 3h1v1H9zM10 4h1v1h-1zM5 5h1v1H5zM7 1h1v1H7zM8 2h1v1H8z"
      />
      <path stroke="currentColor" d="M.465 10.594L4.67 8 8.09 9.947l2.472-1.604" />
    </g>
  </svg>
);

export default InsertPluginMobileIcon;
